import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Es un método difícil de seguir?',
    a: 'No, son ajustes en tu entorno y rutina que toman menos de 5 minutos al día.'
  }, {
    q: '¿Tengo que dejar el café?',
    a: "No, solo aprenderás la 'hora de corte' biológica para que no afecte tu noche."
  }, {
    q: '¿Funciona si tengo años con insomnio?',
    a: 'Sí, porque se basa en mecanismos biológicos universales, no en sugestión.'
  }, {
    q: '¿Es un libro físico?',
    a: 'Es un PDF de descarga inmediata para que empieces esta misma noche.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-10 px-4 md:px-8 bg-[#0f1628]/40" data-id="element-42">
      <div className="max-w-3xl mx-auto" data-id="element-43">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-44">
          <h2 className="text-3xl md:text-4xl font-bold" data-id="element-45">
            Preguntas Frecuentes
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-46">
          {faqs.map((faq, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.4,
          delay: i * 0.1
        }} viewport={{
          once: true
        }} className="border border-slate-600/30 rounded-xl bg-[#0f1628]/50 overflow-hidden" data-id="element-47">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-48">
                <span className="font-bold text-lg text-white" data-id="element-49">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-gray-400 transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-50" />
              </button>
              <AnimatePresence data-id="element-51">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-52">
                    <div className="px-6 pb-6 text-[#b8c4d6]" data-id="element-53">{faq.a}</div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}